import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setAuthHeader } from './apiHelpers';
import { liveAppUrl, demoAppUrl, localAppUrl } from '../../config';

const currentURL = window.location.href;
const appURL = currentURL.includes('localhost') ? localAppUrl : currentURL.includes('glidix') ? demoAppUrl : liveAppUrl;

export const commentApi = createApi({
  reducerPath: 'commentApi',
  baseQuery: fetchBaseQuery({
    baseUrl: appURL,
    prepareHeaders: (headers) => {
      setAuthHeader(headers);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchComment: builder.query({
      query: (params) => {
        if (params?.limit) {
          return `/comment/list?limit=${params?.limit}`;
        } else if (params?.search) {
          return `/comment/list?page=${params?.page ? params?.page : 1}&perPage=${params?.perPage ? params?.perPage : 10}&search=${params.search}`;
        } else {
          return `/comment/list?page=${params?.page ? params?.page : 1}&perPage=${params?.perPage ? params?.perPage : 10}`;
        }
      }
    }),
    deleteComment: builder.mutation({
      query: (id) => ({
        url: `/comment/delete/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useFetchCommentQuery,
  useDeleteCommentMutation
} = commentApi;
